module.exports = __webpack_public_path__ + "media/svg/gb-wls-d4bfee4a.svg";